// src/components/FileUploadForm.jsx
import "survey-core/defaultV2.min.css";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";

import customTheme from "../../Incidents/IncidentForm/survey_theme.json";
import { memo, useRef, useMemo, useEffect } from "react";

function FileUploadForm({ data, handleSave }) {
  const file = useRef(null);

  const setFile = (newFile) => {
    file.current = newFile;
  };

  const survey = useMemo(() => {
    const s = new Model(data);
    s.applyTheme(customTheme);
    s.showCompletedPage = false;
    return s;
  }, [data]);

  useEffect(() => {
    const uploadHandler = (_, options) => {
      const files = options?.files || [];

      if (!files.length) {
        options.callback([]);
        return;
      }

      const readFile = (file) =>
        new Promise((resolve) => {
          const reader = new FileReader();

          reader.onload = () => {
            resolve({
              file,
              content: reader.result ?? "",
            });
          };

          reader.onerror = () => {
            console.error(`Error reading file: ${file.name}`);
            resolve({ file, content: "" });
          };

          reader.readAsDataURL(file);
        });

      Promise.all(files.map(readFile)).then((results) => {
        setFile(files[0]);
        options.callback(results);
      });
    };

    const completeHandler = (sender) => {
      if (!file.current || !sender?.data) {
        console.warn("Missing file data");
        return;
      }
      handleSave(file.current, sender.data);
    };

    survey.onUploadFiles.add(uploadHandler);
    survey.onComplete.add(completeHandler);

    return () => {
      survey.onUploadFiles.remove(uploadHandler);
      survey.onComplete.remove(completeHandler);
    };
  }, [survey, handleSave]);

  return <Survey model={survey} />;
}

export default memo(FileUploadForm);
